import { getQuery, getQueryPostDto } from "app/views/tabellaPocr/ServiceController";

const basePathNre = "/Nre";
const basePathRegistri = "/Registriiva";

export const service = {
    elencoRegistriIva: () =>
        getQuery(`${basePathRegistri}/ElencoRegistriIvaConDefault`),

    creaIdSessione: (payload) =>
        getQueryPostDto(`${basePathNre}/CreaIdSessione`, payload),

    verificaIdSessione: (payload) =>
        getQueryPostDto(`${basePathNre}/VerificaIdSessione`, payload),

    revocaIdSessione: (payload) =>
        getQueryPostDto(`${basePathNre}/RevocaIdSessione`, payload),

    getToken: (idRegistro) =>
        getQuery(`${basePathNre}/GetTokenNre/${idRegistro}`),
};